module.exports = __webpack_public_path__ + "static/img/yy10.436c2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy10.png
// module id = ZN5e
// module chunks = 1